export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">关于我们</h2>
          <p className="text-sm md:text-base text-foreground-500 mt-6 leading-relaxed">
            8090影视是一个专注于电影内容分享与推荐的在线平台。我们致力于为影迷打造一个汇聚最新电影、经典电影和高清电影资源的一站式观影社区。
            平台涵盖华语电影与欧美电影等海量片库，每日持续更新，确保用户能够第一时间欣赏到心仪的影片。
          </p>
          <p className="text-sm md:text-base text-foreground-500 mt-4 leading-relaxed">
            我们的内容团队由资深影评人和电影爱好者组成，精心筛选每一部推荐作品，为用户提供高质量的观影指南和深度影评。
            无论你是院线大片的追随者，还是经典老片的收藏家，8090影视都能满足你对电影的所有期待。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 mt-6 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5"><i className="ri-user-heart-line text-primary-500"></i>5000万+ 影迷选择</span>
            <span className="flex items-center gap-1.5"><i className="ri-movie-2-line text-accent-500"></i>5万+ 影片收录</span>
            <span className="flex items-center gap-1.5"><i className="ri-timer-line text-primary-500"></i>8年 持续运营</span>
          </div>
        </div>
      </div>
    </section>
  );
}